/** Stable key from DashboardStatsController for students without an active enrollment. */
export const UNASSIGNED_BRANCH_KEY = '__UNASSIGNED__';

/** Stable keys from DashboardStatsController healthMix. */
export const HEALTH_MIX_HEALTHY = 'HEALTHY';
export const HEALTH_MIX_AT_RISK = 'AT_RISK';

/**
 * Localize dashboard branch chart labels (keeps real branch names as-is).
 * @param {Array<{ name?: string, value?: number }>} rows
 * @param {(key: string, opts?: object) => string} t
 */
export function localizeStudentsByBranch(rows, t) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => {
    if (row?.name === UNASSIGNED_BRANCH_KEY) {
      return {
        ...row,
        name: t('charts.notEnrolled', { defaultValue: 'Not enrolled' }),
      };
    }
    return row;
  });
}

/**
 * Localize admin health-mix donut labels from stable API keys.
 * Also accepts legacy English labels from older backends.
 */
export function localizeHealthMix(rows, t) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => {
    const key = String(row?.name || '').trim();
    const lower = key.toLowerCase();
    let name = key;
    let atRisk = false;
    if (key === HEALTH_MIX_AT_RISK || lower.includes('risk')) {
      name = t('charts.atRisk', { defaultValue: 'At risk' });
      atRisk = true;
    } else if (key === HEALTH_MIX_HEALTHY || lower === 'healthy') {
      name = t('charts.healthy', { defaultValue: 'Healthy' });
    }
    return { ...row, name, atRisk };
  });
}

/**
 * Localize coach hours-by-weekday bars. Prefers ISO day 1–7; falls back to legacy EN shorts.
 */
export function localizeHoursByWeekday(rows, t) {
  if (!Array.isArray(rows)) return [];
  const legacy = {
    mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6, sun: 7,
  };
  return rows.map((row) => {
    let day = Number(row?.day);
    if (!Number.isInteger(day) || day < 1 || day > 7) {
      day = legacy[String(row?.name || '').trim().toLowerCase()] || null;
    }
    if (!day) return row;
    return {
      ...row,
      day,
      name: t(`days.short.${day}`, { defaultValue: String(row?.name || day) }),
    };
  });
}
